<template>
  <v-row no-gutters>
    <v-col>
      <v-card flat>
        <v-card-title class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Синхронізація с Jira"
            disabled
            :search-field="false"
          >
            <template v-slot:sync>
              <SyncBtn
                :start.sync="startDate"
                :loading="syncLoading"
                @change="syncData()"
              />
              <ModalLoader
                title="Виконується синхронізація з Jira"
                :loading="syncLoading"
              />
            </template>
            <template v-slot:filters>
              <v-row class="px-1 py-0">
                <v-col
                  cols="4"
                  class="py-0"
                >
                  <DateRangePicker
                    :start.sync="dateFrom"
                    :end.sync="dateTo"
                    label="Період"
                    :filled="false"
                    @change="getData()"
                  />
                </v-col>
                <v-spacer />
                <v-col
                  cols="5"
                  class="py-0"
                >
                  <v-switch
                    v-model="onlyMistaked"
                    class="ml-2"
                    color="green"
                    label="Тільки синхронізації з помилкою"
                    true-value="false"
                    false-value=""
                    @change="getData()"
                  />
                </v-col>
              </v-row>
            </template>
          </DataListHeading>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :loading="loading"
          no-data-text="Дані відсутні"
          loading-text="Завантаження данних"
          disable-sort
          hide-default-footer
          :items-per-page="rowsCount"
          class="elevation-1 mb-1"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.startedAt | dateTime }}
              </td>
              <td>
                {{ item.syncFrom | date }}
              </td>
              <td>
                <v-row>
                  <v-chip
                    small
                    label
                    :color="getJiraLabelColor(item)"
                    text-color="white"
                    class="mr-2"
                  >
                    {{ getJiraLabelText(item) }}
                  </v-chip>
                  <v-spacer />
                  <Clipboard
                    :text="item.id"
                    tooltip-text="Скопіювати id синхронізації"
                  />
                </v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="pages()"
          :total-visible="10"
          color="red lighten-2"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import DateRangePicker from "@/components/story/DateRangePicker";
import * as syncOperationsApi from "../../../backend/jiraApi.js";
import Clipboard from "../../../components/Clipboard.vue";
import DataListHeading from "../../../components/DataListHeading.vue";
import SyncBtn from "./SyncBtn.vue";
import ModalLoader from "@/components/ModalLoader.vue";

export default {
  components: {
    DateRangePicker,
    Clipboard,
    DataListHeading,
    SyncBtn,
    ModalLoader,
  },
  data() {
    return {
      headers: [{ text: "Дата запуска" }, { text: "Период синхронизации" }, { text: "Статус" }],
      totalItems: 0,
      items: [],
      loading: false,
      dateFrom: "",
      dateTo: "",
      onlyMistaked: null,
      page: 1,
      rowsPerPage: Number,
      startDate: null,
      syncLoading: false,
    };
  },
  computed: {
    filteredItems() {
      return this.items.sort((a, b) => {
        const dateA = new Date(a.startedAt);
        const dateB = new Date(b.startedAt);
        return dateB - dateA;
      });
    },
    rowsCount() {
      if (this.items.length !== 0) {
        return Math.floor((window.innerHeight - 280) / 50);
      } else {
        return Math.floor((window.innerHeight - 200) / 50);
      }
    },
  },
  watch: {
    page: {
      handler() {
        if (this.page) {
          this.getData();
        }
      },
    },
  },
  created() {
    this.rowsPerPage = this.rowsCount;
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const response = await syncOperationsApi.fetchAll(
        this.page,
        this.rowsPerPage,
        this.dateFrom,
        this.dateTo,
        this.onlyMistaked
      );
      this.items = response.result;
      this.totalItems = response.totalItems;

      this.loading = false;
    },
    getJiraLabelColor(item) {
      if (item.finishedAt) {
        return "green";
      } else {
        return "red";
      }
    },
    getJiraLabelText(item) {
      if (item.finishedAt) {
        return "пройшла успішно";
      } else {
        return "не завершилася";
      }
    },
    pages() {
      if (this.rowsPerPage === null || this.totalItems === null) {
        return 0;
      }
      return Math.ceil(this.totalItems / this.rowsPerPage);
    },
    async syncData(){
      this.syncLoading = true;
      try {
        await syncOperationsApi.syncData(this.startDate);
      } catch {
        this.$notifyWarning("Під час синхронізації сталася помилка");
      } finally {
        this.syncLoading = false;
      }
    },
  },
};
</script>